export const withHashUrl = (url: string) =>
  [window.location.origin, '/#', url].join('');
